import { FC, ReactElement, useMemo } from 'react';

import { ProductAttributeKey } from '../../../../../entities/@api/Sylius';
import { ProductAttribute } from '../../../../../entities/@products/ProductAttribute/ProductAttribute';

import './ProductTableInformation.scss';

interface ProductTableInformationProps {
    attributes: ProductAttribute[];
    className?: string;
}

export const ProductTableInformation: FC<ProductTableInformationProps> = ({
    attributes,
    className = '',
}): ReactElement => {
    const metaAttributeKeys = [ProductAttributeKey.sku, ProductAttributeKey.barcode];

    const metaAttributes = useMemo((): ProductAttribute[] => (
        attributes.filter(attribute => (
            metaAttributeKeys.includes(attribute.key as ProductAttributeKey)
        ))
    ), [attributes]);

    const restAttributes = useMemo((): ProductAttribute[] => (
        attributes.filter(attribute => (
            !metaAttributeKeys.includes(attribute.key as ProductAttributeKey)
        ))
    ), [attributes]);

    return (
        <table className={`product-table-information ${className}`}>
            <tbody>
                {restAttributes.map(attribute => (
                    <tr key={attribute.key} className="product-table-information__row">
                        <td className="product-table-information__cell">
                            {attribute.label}
                        </td>

                        <td className="product-table-information__cell">
                            {attribute.value}
                        </td>
                    </tr>
                ))}

                {metaAttributes.map(attribute => (
                    <tr key={attribute.key} className="product-table-information__row">
                        <td className="product-table-information__cell">
                            {attribute.label}
                        </td>

                        <td className="product-table-information__cell">
                            {attribute.value}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
